import { render, staticRenderFns } from "./MallMainPageV2.vue?vue&type=template&id=c1dbb00a&scoped=true"
import script from "./MallMainPageV2.vue?vue&type=script&lang=js"
export * from "./MallMainPageV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dbb00a",
  null
  
)

export default component.exports